exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bem-vindo[data-v-10e9af0c] {\n  line-height: 1.1;\n  margin-bottom: 15px;\n}\n.video-bem-vindo[data-v-10e9af0c] {\n  border-style: none;\n  -webkit-box-ordinal-group: 4;\n      -ms-flex-order: 3;\n          order: 3;\n}\n@media (max-width: 727px) {\n.video-bem-vindo[data-v-10e9af0c] {\n    position: absolute;\n    left: 0;\n}\n}", ""]);

// exports
